import { render, staticRenderFns } from "./languageSwitcher.vue?vue&type=template&id=2505659d&scoped=true"
import script from "./languageSwitcher.vue?vue&type=script&lang=js"
export * from "./languageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./languageSwitcher.vue?vue&type=style&index=0&id=2505659d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505659d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2505659d')) {
      api.createRecord('2505659d', component.options)
    } else {
      api.reload('2505659d', component.options)
    }
    module.hot.accept("./languageSwitcher.vue?vue&type=template&id=2505659d&scoped=true", function () {
      api.rerender('2505659d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/languageSwitcher.vue"
export default component.exports